import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoanApplicationService } from '../loan/services/loan-application.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RejectLoanDialogueComponent } from '../loan/reject-loan-dialogue/reject-loan-dialogue.component';
import { SanctionLoanDialogueComponent } from '../loan/sanction-loan-dialogue/sanction-loan-dialogue.component';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonGalleryDialogComponent } from 'src/app/shared/common-gallery-dialog/common-gallery-dialog.component';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { ContentService } from 'src/app/shared/services/content.service';
import { ActivatedRoute } from '@angular/router';
import numWords from 'num-words';


@Component({
  selector: 'app-loan-pdf-view',
  templateUrl: './loan-pdf-view.component.html',
  styleUrls: ['./loan-pdf-view.component.scss']
})

export class LoanPdfViewComponent implements OnInit {

  @ViewChild("print") print!: ElementRef;
  @ViewChild('bottomElement', { static: false }) bottomElement!: ElementRef;
  // @ViewChild('upElement', { static: false }) upElement!: ElementRef;



  dataFromLoanList: any;
  @Input() buttonShow: boolean = false;
  pdfData: any ={}
  headMembers: any = []
  list: any = []
  witnessethList: any = []
  loanAgreementForm: any = []
  shgAssessment: any = []
  tableData: any = []
  resolutionHeader: any = []
  resolutionTable: any = []
  incomeArr: any = []
  expenditureArr: any = []
  assetsArr: any = []
  liabilitiesArr: any = []
  totalAssets: any = 0;
  totalExpenditure: any = 0;
  totalIncome: any = 0;
  totalLiabilities:any = 0;
  membersList: any = [];
  isLoading: boolean = false;
  leaderPriority: any = {
    "President": 1,
    "Secretary": 2,
    "Treasurer": 3,
    "Member": 4
  };
  isSanction: boolean = false;

  constructor(
    public loanApplicationService: LoanApplicationService,
    public dialog: MatDialog,
    private location: Location,
    // private dialogRef: MatDialogRef<LoanPdfViewComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any
    public contentService:ContentService,
    private activeRoute: ActivatedRoute
  ) { }

  @Input() shgLoanId:any = '';
  @Input() xTenantId: string = ''
  @Output() backList: any = new EventEmitter();

  ngOnInit(): void {
    this.activeRoute.paramMap.subscribe((params: any) => {
      this.shgLoanId = params.get('id');
    });

    this.activeRoute.queryParamMap.subscribe((queryParams: any) => {
      this.isSanction = queryParams.get('isSanction');
      // console.log('Is Sanction:', this.isSanction);
    });

    // console.log('ShgLoanId: ', this.shgLoanId);

    this.getPdfData(this.shgLoanId)
    // this.dataFromLoanList = history.state.data || {shgLoanId: this.shgLoanId,xTenantId: this.xTenantId};

    // console.log('DataFromLoanList: ', history.state.data , this.dataFromLoanList);

    // if(this.dataFromLoanList && this.dataFromLoanList.shgLoanId ) {
    //   this.getPdfData(this.dataFromLoanList.shgLoanId);
    // }

  }


  createAllList() {
    this.list = [{
      points : `We, the duly authorized representatives of (${this.pdfData?.shgName} ${this.pdfData?.districtName}, ${this.pdfData?.grampanchayatName} , ${this.pdfData?.villageName}) hereby apply by way of Cash Credit(CC)/Term Loan(TL) for on-lending to our members. A copy of resolution taken by our Self Help Group in this regard is attached.`
    },
    {
      points : 'A copy of the member-wise requirement of loan is enclosed (Compulsory from 3rd linkage onwards)'
    },
    {
      points : 'We agree to repay the Term Loan loan amount as per the repayment schedule which may be fixed by the Bank. or/and We agree to operate the Cash Credit account satisfactorily and within the limit and shall repay the interest charged in the Cash Credit account from time to time or on demand without demur as per the terms and conditions stipulated by Bank.'
    },
    {
      points : 'A copy of the Inter-se Agreement executed by all the members of the group authorizing us inter alia to borrow on behalf of the SHG is enclosed.'
    },
    {
      points : 'We hereby declare that the particulars given above are true and correct to the best of our knowledge and belief.'
    },
    {
      points : 'We hereby authorize the Bank to disclose all or any particulars or details or information relating to our loan accounts with the Bank, to any other financial institution including NABARD, Government or any agency as may be considered necessary or desirable by the Bank. It will be in order for the Bank to disqualify the SHG from receiving any credit facilities from the Bank and or recall the entire loan amount or any part thereof granted on this application, if any of the information pertaining to the group, furnished herewith is found incorrect and/or containing misrepresentation of facts.'
    },
    {
      points : 'We undertake that the Credit Information Bureau (India)Ltd. and any other agency so authorized may use, process the said particulars disclosed by the Bank in the manner as deemed fit by them and I/We shall not raise any dispute in whatsoever manner regarding information/details furnished/to be furnished to CIBIL/other authorities and same is binding on me/us.'
    },
    {
      points : `A copy of the financial status of our SHG as on ${moment(this.pdfData?.mcpDate).format('DD/MM/YY')} is attached.`
    },
  ]

    this.witnessethList = [{
      list : `Each member of the SHG shall save a sum of Rs.100 (one hundred Rupees only) or such sum as may be decided by the Group, on (weekly fortnightly/monthly) basis during the scheduled SHG meeting. The accumulated corpus of the SHG shall be given on loan to members based on their need and recovered along with interest as decided by the SHG members.`
    },
    {
      list : 'The SHG will take the responsibility for maintaining appropriate books of accounts to ensure transparency in transaction among SHG members'
    },
    {
      list : 'Each member shall strive for the success of the SHG and shall not act in any manner detrimental to the business interests of the SHG.'
    },
    {
      list : 'The SHG members shall be jointly and severally liable for all the debts contracted by the SHG.'
    },
    {
      list : `All assets and goods acquired by the SHG shall be in the joint ownership of all the members of the SHG and shall ordinarily be in the constructive custody of such member as may be authorized by the Group and shall be kept at the place of business at ${this.pdfData?.districtName}, ${this.pdfData?.grampanchayatName} , ${this.pdfData?.villageName} which shall not be changed without consent of the SHG members.`
    },
    {
      list : `The SHG members hereby duly elect and appoint  <b class='fw-bold'> ${this.headMembers[0]?.memberName ? this.headMembers[0]?.memberName : 'President not appointed'} (${this.headMembers[0]?.leader ? this.headMembers[0]?.leader : ''}) ,</b>  <b class='fw-bold'>${this.headMembers[1]?.memberName ? this.headMembers[1]?.memberName : 'Secretary not appointed'} (${this.headMembers[1]?.leader ? this.headMembers[1]?.leader : ''} ) &</b><b class='fw-bold'>${this.headMembers[2]?.memberName  ? this.headMembers[2]?.memberName : 'Treasurer not appointed'} ( ${this.headMembers[2]?.leader ? this.headMembers[2]?.leader : ''} )</b>      to look after and manage the day to day affairs of the SHG's activities and also act in the name of the SHG all matters relating thereto. The authorized representatives, may however, be removed at any time by majority vote of the members and new representatives elected.`
    },
    {
      list : 'Each of the SHG members hereby agrees to abide by and ratify all such act, deeds and things as the authorized representatives may do in the interest of the said activities.'
    },
    {
      list : 'The authorized representatives shall take decisions in the day to day working of the SHG and each representative shall actively involve herself and co-operate in looking after the day-to-day affairs of the SHG activities in particular to attend to the following activities. - Every member of the SHG hereby authorizes the representatives to apply for the loan on behalf of the SHG and execute necessary agreements/documents on behalf of the SHG for the purpose. The authorized representative may collect loan amounts from the bank on behalf of SHG, deposit the same in the savings account of the SHG in case of Term Loans for on-lending to members in accordance with the decision of the SHG and also deposit recovery of loan installment from members in the loan account/s of SHG with the bank.'
    },
    {
      list : 'The SHG members hereby specifically authorize the representatives:-'
    },
    {
      list : `To open Savings, Fixed Deposits and other accounts in ${this.pdfData?.reviewedBankName} Branch of ${this.pdfData?.reviewedBranchName} Bank approved by the SHG and operate the same under the joint signature of any two of the following authorized representatives:`
    },
    {
      list : `${this.headMembers[0]?.memberName} (${this.headMembers[0]?.leader}), ${this.headMembers[1]?.memberName} (${this.headMembers[1]?.leader}), ${this.headMembers[2]?.memberName} (${this.headMembers[2]?.leader})`
    },
    {
      list : 'To keep or cause to be kept proper books of accounts of the savings, made by the SHG Members, loans granted to them and the recoveries made from them and render every year thefull accounts to the SHG members for their approval and adoption;'
    },
    {
      list : 'To receive all payments due to the SHG and issue requisite receipts or acknowledgments for and on behalf of the SHG;'
    },
    {
      list : 'To institute and defend on behalf of the SHG members any legal proceedings and safeguard the interests of each member of the said SHG and for this purpose engage or disengage any lawyer or advocate or agent and incur the necessary legal expenses in connection therewith.'
    },
    {
      list : 'In the event of death of any of the members of the SHG, his/her legal heirs shall be entitled or the benefits and be liable for the obligations of the deceased member under this agreement.'
    },
    {
      list : 'It is agreed that no new person shall be inducted as a member of the SHG without consent of all the existing members.'
    }];

    this.loanAgreementForm = [{
      point : "The Bank has agreed to grant and the borrower has agreed to borrow by way of Term Loan Cash / Credit (clean) up to the limit of Rs <span class='text-decoration-underline d-inline-block form_underline'></span> (Rupees <span class='text-decoration-underline d-inline-block form_underline'></span> only) and the Bank has opened (SPECIFY THE KIND OF LOAN ACCOUNT) <span class='text-decoration-underline d-inline-block form_underline'></span> A/C No <span class='text-decoration-underline d-inline-block form_underline'></span> of date <span class='text-decoration-underline d-inline-block form_underline'></span> in the name of the Borrower in its book of accounts."
    },
    {
      point : '*In case the facility availed is Cash Credit the Borrowers will operate the Cash Credit account satisfactorily and within the limit and the Borrower shall repay the interest charged in the Cash Credit account from time to time or on demand without demur.'
    },
    {
      point : '*In case loan availed is Demand Loan, without prejudice to the right of the Bank to recall the loan on demand the Borrower undertakes to repay the loan with interest and other within the period stipulated in terms of sanction.'
    },
    {
      point : '*In case the credit facility availed of by the borrower is a Term Loan the same shall be repayable in installments in the manner specified herein-below in the repayment schedule. (to be specified) Besides the borrower will pay interest at the rates that may be prescribed for such lending by RBI/NABARD from time to time.'
    },
    {
      point : "It is clearly understood by and between the parties hereto that in the event of the borrower's failure to utilize the proceeds of the credit facility for the purpose for which the same has been made available by the bank to the borrower, the borrower shall repay immediately on demand without demur together with interest without prejudice to Bank's right to initiate other legal action."
    },
    {
      point : 'The borrower shall pay interest on the loans to be calculated on the daily balances in the loan account and be debited thereto at monthly/quarterly rests or as the Bank may decide'
    },
    {
      point : 'The borrower should utilize the proceeds of the credit facility for the purpose of lending to is members to improve the socio-economic conditions of their members and their families. That the loan will not be used for any Speculative purpose / activities prohibited by law.'
    },
    {
      point : 'The borrower shall repay the Term Loan facility availed of together with interest payable as per the interest rates that may be fixed by bank from time to time for such lending'
    },
    {
      point : 'The borrower shall be liable to repay the facility on demand together with the interest and other charges payable by the borrower to the bank in accordance with the rules of the Bank.'
    },]

    this.shgAssessment = [{
      list : 'Whether the SHG has completed 6 months from the date of formation / 12 months from the date of last sanction : Yes / No (*Strike out which is not applicable)'
    },
    {
      list : 'Whether the SHG has been Graded / Evaluated : Yes / No (*Strike out which is not applicable)'
    },
    {
      list : 'Whether the SHG has passed the Grading / Evaluation Exercise: Yes / No (*Strike out which is not applicable)'
    },
    {
      list : '% of Marks obtained in the Grading / Evaluation Exercise: ...............................................'
    },
    {
      list : `Financial Position of the SHG (as on ${moment(this.pdfData?.mcpDate).format('DD/MM/YY')}).`
    }];

    this.tableData = []


    this.resolutionHeader = [];

   this.resolutionTable = []
  }

  createFinancialList() {
    this.pdfData?.financials.forEach((ele: any) => {
      if (ele.acType == 1) {
        this.expenditureArr.push(ele);
      } else if (ele.acType == 2) {
        this.incomeArr.push(ele);
      } else if (ele.acType == 3) {
        this.liabilitiesArr.push(ele);
      } else {
        this.assetsArr.push(ele);
      }
    });

    this.totalAssets = 0;
    this.assetsArr?.forEach((element: any) => {
      this.totalAssets = this.totalAssets + +element?.amount;
    });

    this.totalExpenditure = 0;
    this.expenditureArr?.forEach((element: any) => {
      this.totalExpenditure = this.totalExpenditure + +element?.amount;
    });

    this.totalIncome = 0;
    this.incomeArr?.forEach((element: any) => {
      this.totalIncome = this.totalIncome + +element?.amount;
    });

    this.totalLiabilities = 0;
    this.liabilitiesArr?.forEach((element: any) => {
      this.totalLiabilities = this.totalLiabilities + +element?.amount;
    })

    this.expenditureArr = this.expenditureArr.sort((a: any, b: any) => {
      return a.sequence - b.sequence;
    });

    this.incomeArr = this.incomeArr.sort((a: any, b: any) => {
      return a.sequence - b.sequence;
    });

    this.liabilitiesArr = this.liabilitiesArr.sort((a: any, b: any) => {
      return a.sequence - b.sequence;
    });

    this.assetsArr = this.assetsArr.sort((a: any, b: any) => {
      return a.sequence - b.sequence;
    });
  }


  printPage() {
    // const DATA = document.getElementById('htmlData')!;
    // console.log('Data HTML: ', DATA);
    // window.print();

    const printContent = document.getElementById('htmlData')!.innerHTML;
    this.contentService.print(printContent);
  }


  getPdfData(shgLoanId: number) {
    this.loanApplicationService.getPDFviewData(shgLoanId).subscribe((res: any)=>{
      // console.log('PDF Data: ',res.wrapperList[0]);
      this.pdfData = res.wrapperList[0]
      this.dataFromLoanList = res.wrapperList[0]
      this.HeadMembersList( res.wrapperList[0]?.members)
      this.addAgeToObjects(this.pdfData?.members)
    })
  }

  HeadMembersList(dataArr: any) {

    dataArr?.forEach((ele: any) => {
      if(ele.leader == "President" || ele.leader == "Secretary" || ele.leader == "Treasurer" ) {
        this.headMembers.push(ele);
      }
    });


    this.headMembers = this.headMembers.sort((a: any, b: any) => {
      const priority: any = {
          "President": 1,
          "Secretary": 2,
          "Treasurer": 3,
      };

      const getPriority = (leader: any) => priority[leader] || priority["default"];
      return getPriority(a.leader) - getPriority(b.leader);
  });

    // console.log('HeadMembers: ', this.headMembers);

    this.createAllList()
    this.createFinancialList()
  }

  scrollToBottom(): void {
    this.bottomElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  // scrollToUp(): void {
  //   this.upElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  // }


   calculateAge(dob: any) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

   addAgeToObjects(array: any) {
     this.membersList = array.map((person: any) => {
      const age = this.calculateAge(person.dob);
      return { ...person, age };
    });

    // console.log('MembersList: ', this.membersList);

    this.membersList = this.membersList.sort((a: any, b: any) => {
      const priority: any = {
          "President": 1,
          "Secretary": 2,
          "Treasurer": 3,
          "default": 4
      };

      const getPriority = (leader: any) => priority[leader] || priority["default"];
      return getPriority(a.leader) - getPriority(b.leader);
  });
    // return this.membersList
  }

  goBack() {
      this.location.back();
  }


  openRejectDialog(formData: any): void {
    const dialogRef = this.dialog.open(RejectLoanDialogueComponent, {
      data: {shgLoanId: this.shgLoanId, formData},
      width:'500px',
      height : '300px'
    });

    dialogRef.afterClosed().subscribe(result => {
      // if (result== true) {
      //   this.goBack();
      // }
    });
  }

  openSanctionDialog(formData: any): void {
    // console.log('FormDataPDF: ', formData);

    const dialogRef = this.dialog.open(SanctionLoanDialogueComponent, {
      data: {shgLoanId: this.shgLoanId, submissionDate: this.pdfData.submissionDate, formData},
      width:'650px',
      height : '455px'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      // if (result== true) {
      //   this.goBack();
      // }
    });
  }

  get amountInWords(): string {
  const amount = this.pdfData?.mcpTotalLoanAmount || 0;
  return amount ? this.toTitleCase(this.convertToWords(amount)) + ' rupees only' : '';
}

convertToWords(amount: number): string {
  // Simple method if you don't use a library
  const a = require('num-words'); // if using num-words
  return a(amount);
}

toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, (txt) =>
    txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
  );
}



  public downloadPDF(): void {
    this.isLoading = true; // Show the loader

    const DATA = document.getElementById('htmlData')!;
    // console.log('Data HTML: ', DATA);

    html2canvas(DATA, { scale: 2 }).then(canvas => {
        const imgWidth = 208;
        const pageHeight = 295;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/jpeg', 0.5); // Use JPEG with quality setting
        const pdf = new jsPDF('p', 'mm', 'a4');
        let position = 0;

        pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save('SHG Loan Application.pdf');
        this.isLoading = false; // Hide the loader when done
    }).catch(error => {
        console.error('Error generating PDF: ', error);
        this.isLoading = false; // Hide the loader if there's an error
    });
  }

openDialog(fileList: any, type: string) {
  // console.log('Loan File List: ', fileList);
  let loanFileList = {}
  if(type == 'kyc') {
   loanFileList = {
      contentId: fileList.id,
      downloadCount: 0,
      fileSize: '',
      fileType: 'jpg',
      fileUrl: `${fileList.kycImage}`,
      id: fileList.id,
      thumbnail: '',
      viewCount: 0,
    }
  } else {
   loanFileList = {
      contentId: fileList.id,
      downloadCount: 0,
      fileSize: '',
      fileType: 'png',
      fileUrl: `${fileList.photo}`,
      id: fileList.id,
      thumbnail: '',
      viewCount: 0,
    }
  }


  


  const dialogRef = this.dialog.open(CommonGalleryDialogComponent, {
    data: {
      fileList: [loanFileList],
    },
    width: '800px',
    height: 'auto',
  });
  dialogRef.afterClosed().subscribe((result: any) => {
    // console.log(`Dialog result: ${result}`);
  });
}

}
